/**
 * !!! Ce ne sont pas des routes mais des JourneyPattern
 */
angular.module("app").directive("tchRouteSelector", ["ExploitationService", "$q", function (ExploitationService, $q) {
	return {
		restrict: "E",
		templateUrl: "common/directives/exploitation/route/tchRouteSelectorDirective.html",
		replace: true,
		scope: {
			data: "=tchRouteSelectorData",
			callback: "&tchRouteSelectorCallback",
			callbackAfterLoad: "&tchRouteSelectorCallbackAfterLoad", // après le chargement des courses de la route sélectionnée ce callback est appelé
			useCache: "=tchRouteSelectorCache",
			doNotFetch: "=tchRouteSelectorDoNotFetch"
		},

		link: function (scope) {

			scope.routeSelected = function () {
				scope.callback({route: scope.data.currentRoute});

				if (!scope.doNotFetch && !scope.data.routeDataChanged) {
					if (scope.data.currentRoute) {

						const promises = [
							ExploitationService.getRoute(scope.data.currentRoute, scope.useCache !== undefined ? scope.useCache : false),
							ExploitationService.getCoursesByType("route", scope.data.currentRoute, scope.useCache !== undefined ? scope.useCache : false)
						];
						$q.all(promises).then(results => {
							scope.data.currentRouteData = results[0].data;
							scope.data.courses = results[1].data;

							if (scope.callbackAfterLoad) {
								scope.callbackAfterLoad();
							}
						});

					} else {
						scope.data.courses = {};
						scope.data.currentCourseData = {};
						scope.data.currentCourse = undefined;
					}
				}

			};

			/**
			 * A chaque changement de la route on doit recharger les courses
			 */
			scope.$watch("data.currentRoute", () => {
				if (scope.data.currentRoute) {
					scope.routeSelected();
				}
			})

		}
	};
}]);
